<template>
  <b-row>
    <b-col cols="12" class="d-flex justify-content-end my-1">
      <b-button  v-if="HasPermission(PermissionList.Sales_Create)" variant="primary" @click="$bvModal.show('add-opportunity-modal')">
        Add Opportunity
      </b-button>
    </b-col>

    <b-col md="2" sm="4" class="my-1">
      <b-form-group class="mb-0">
        <label class="d-inline-block text-sm-left mr-50">Per page</label>
        <b-form-select id="perPageSelect" v-model="perPage"
          :options="pageOptions.map(option => ({ text: option, value: option }))" size="sm" class="w-50" />

      </b-form-group>
    </b-col>
    <b-col md="10" class="my-1">
      <b-form-group label="Filter" label-cols-sm="8" label-align-sm="right" label-size="sm" label-for="filterInput"
        class="mb-0">
        <b-input-group size="sm">
          <b-form-input id="filterInput" v-model="searchQuery" type="search"
            placeholder="Type to Search" />
          <b-input-group-append>
            <b-button :disabled="!searchQuery" @click="searchQuery = ''">
              Clear
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <!-- Status Tabs -->
      <b-tabs v-model="currentTab" class="mb-3">
        <b-tab title="All" active></b-tab>
        <b-tab v-for="option in statusOptions" :title="option.text" :key="option.value"></b-tab>
      </b-tabs>
    </b-col>

    <b-col cols="12" class="my-1">
      <b-form-group label="Select Columns:" class="mb-0">
        <b-form-checkbox-group v-model="selectedColumns" :options="columnOptions"></b-form-checkbox-group>
      </b-form-group>
    </b-col>


    <b-col cols="12">
      <b-table striped hover responsive :items="opplist" :fields="dynamicFields" :filter="searchQuery" :per-page="perPage"
        :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" v-if="showTable">

        <template #cell(expectedCloseDate)="data">
          {{ formatDate(data.item.expectedCloseDate) }}
        </template>
        <template #cell(openDate)="data">
          {{ formatDate(data.item.openDate) }}
        </template>
        <template #cell(closeDate)="data">
          {{ formatDate(data.item.closeDate) }}
        </template>
        <template #cell(status)="data">
          <b-badge :variant="getBadgeVariant(data.item.status)">{{ beautifyStatus(data.item.status) }}</b-badge>
        </template>
        <template #cell(estimateValue)="data">
          Rs {{ formatAmount(data.item.estimateValue) }}
        </template>
        <template #cell(salespersonId)="data">
          {{ getSalePersonName(data.item.salespersonId) }}
        </template>
        <template #cell(description)="data">
          {{ data.item.description || ' - ' }}
        </template>

        <template #cell(actions)="data">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
            </template>
            <b-dropdown-item v-if="HasPermission(PermissionList.Sales_View)" :to="viewOpportunity(data.item.id)">
              <feather-icon icon="EyeIcon" class="mr-50" />
              <span>View</span>
            </b-dropdown-item>
            <b-dropdown-item @click="prepareEditOpportunity(data.item)">
              <feather-icon icon="Edit2Icon" class="mr-50" />
              <span>Edit</span>
            </b-dropdown-item>
            <b-dropdown-item v-if="HasPermission(PermissionList.Sales_Delete)" @click="deleteOpportunity(data.item.id)">
              <feather-icon icon="TrashIcon" class="mr-50" />
              <span>Delete</span>
            </b-dropdown-item>
            <b-dropdown-item v-if="isEdit" @click="promptChangeStatus(data.item)">
              <feather-icon icon="RotateCcwIcon" class="mr-50" />
              <span>Change Status</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
      <div class="d-flex justify-content-center mb-1">
        <b-spinner variant="success" label="Spinning" block v-if="loadingopp"
          style="width: 3rem; height: 3rem"></b-spinner>
      </div>
      <b-col cols="12">
        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="center" size="sm"
          class="my-0"></b-pagination>
      </b-col>
    </b-col>

    <!-- Modal for Status Change -->
    <b-modal id="change-Opportunity-status-modal" title="Change Opportunity Status" @ok="changeStatus">
      <b-form-group label="Select New Status:" label-for="status-select">
        <b-form-select id="status-select" v-model="selectedStatus" :options="statusOptions" @change="isStatusChangeDisabled"></b-form-select>
      </b-form-group>
      <template #modal-footer="{ ok, cancel }">
        <b-button @click="cancel" variant="secondary">Cancel</b-button>
        <b-button @click="ok" :disabled="isStatusChangeDisabled" variant="primary">Change Status</b-button>
      </template>
    </b-modal>

    <!-- Modal for add -->
    <b-modal id="add-opportunity-modal" title="Add Opportunity" @ok.prevent="onSubmit" @hidden="resetForm">
      <b-row>
        <b-col cols="12" class="mx-auto">
          <b-card title="Add Opportunity" class="mb-3">
            <validation-observer ref="AddForm" #default="{ invalid }">
              <b-form @submit.prevent="onSubmit">
                <template>
                  <b-form-group label="Lead Name:" label-for="customer-lead">
                    {{ getLeadName(id) }}
                  </b-form-group>
                </template>
                <b-form-group label="Assign to*" label-for="salesperson">
                  <validation-provider #default="{ errors }" name="Salesperson" vid="Salesperson" rules="required">
                    <b-form-select v-model="form.salespersonId" :options="salesPersonOptions" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group label="Opportunity Name:" label-for="name">
                  <validation-provider #default="{ errors }" name="Opportunity Name" vid="Opportunity Name"
                    rules="required">
                    <b-form-input id="name" type="text" v-model="form.name" required
                      placeholder="Enter Opportunity Name"></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group label="Status:" label-for="status-select">
                  <validation-provider #default="{ errors }" name="Status" vid="Status" rules="required">
                    <b-form-select id="status-select" v-model="form.status" :options="statusOptions"
                      required></b-form-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group label="Amount:" label-for="amount">
                  <b-form-input id="amount" type="number" v-model="form.estimateValue" required
                    placeholder="Enter amount"></b-form-input>
                </b-form-group>
                <b-form-group label="Expected Close Date:" label-for="expected-close-date">
                  <b-form-datepicker id="expected-close-date" v-model="form.expectedCloseDate" required
                    placeholder="Select a date">
                  </b-form-datepicker>
                </b-form-group>
                <b-form-group label="Description:" label-for="Description">
                  <b-form-textarea id="textarea-default" placeholder="Description" rows="3" v-model="form.description"
                    required />
                </b-form-group>
              </b-form>
            </validation-observer>
          </b-card>
        </b-col>
      </b-row>
      <template #modal-footer="{ ok }">
        <b-button variant="primary" @click="onSubmit" :disabled="submitting">
          <b-spinner small v-if="submitting"></b-spinner>
          {{ submitting ? 'Adding...' : 'Add' }}
        </b-button>
      </template>
    </b-modal>

    <b-modal id="edit-opportunity-modal" title="Edit Opportunity" @ok.prevent="updateOpportunity">
      <b-row>
        <b-col cols="12" class="mx-auto">
          <b-card title="Edit Opportunity" class="mb-3">
            <validation-observer ref="EditForm" #default="{ invalid }">

              <b-form @submit.prevent="updateOpportunity">

                <template>
                  <b-form-group label="Lead Name:" label-for="customer-lead">
                    {{ getLeadName(id) }}
                  </b-form-group>
                </template>
                <b-form-group label="Assign to*" label-for="salesperson">
                  <validation-provider #default="{ errors }" name="Salesperson" vid="Salesperson" rules="required">
                    <b-form-select v-model="editFormData.salespersonId" :options="salesPersonOptions" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group label="Opportunity Name:" label-for="name">
                  <validation-provider #default="{ errors }" name="Opportunity Name" vid="Opportunity Name"
                    rules="required">
                    <b-form-input id="name" type="text" v-model="editFormData.name" required
                      placeholder="Enter Opportunity Name"></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group label="Status:" label-for="status-select">
                  <validation-provider #default="{ errors }" name="Status" vid="Status" rules="required">
                    <b-form-select id="status-select" v-model="editFormData.status" :options="statusOptions"
                      required></b-form-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group label="Amount:" label-for="amount">
                  <b-form-input id="amount" type="number" v-model="editFormData.estimateValue" required
                    placeholder="Enter amount"></b-form-input>
                </b-form-group>
                <b-form-group label="Expected Close Date:" label-for="expected-close-date">
                  <b-form-datepicker id="expected-close-date" v-model="editFormData.expectedCloseDate" required
                    placeholder="Select a date">
                  </b-form-datepicker>
                </b-form-group>
                <b-form-group label="Description:" label-for="Description">
                  <b-form-textarea id="textarea-default" placeholder="Description" rows="3"
                    v-model="editFormData.description" required />
                </b-form-group>
              </b-form>
            </validation-observer>
          </b-card>
        </b-col>
      </b-row>
      <template #modal-footer="{ ok }">
        <b-button variant="primary" @click="updateOpportunity" :disabled="submitting">
          <b-spinner small v-if="submitting"></b-spinner>
          {{ submitting ? 'Editing...' : 'Edit' }}
        </b-button>
      </template>
    </b-modal>
  </b-row>
</template>

<script>
import Ripple from "vue-ripple-directive";
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BAlert,
  BCol,
  BFormGroup,
  BFormSelect,
  BTab,
  BTabs,
  BContainer,
  BPagination,
  BInputGroup,
  BFormInput,
  BForm,
  BFormDatepicker,
  BInputGroupAppend,
  VBModal,
  BButton,
  BSpinner,
  BModal,
  BDropdown,
  BFormTextarea,
  BDropdownItem,
  BFormCheckboxGroup,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { fnSortingDropdown } from "@/libs/customFn";
import { required } from "@validations";
import { PermissionList } from '@/libs/defaultList';
import { HasPermission } from '@/@core/utils/validations/permissionCheck';
export default {
  components: {
    BTable,
    BAvatar,
    BForm,
    BTab,
    BTabs,
    BModal,
    BBadge,
    BRow,
    BContainer,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    VBModal,
    BFormInput,
    BFormDatepicker,
    BFormTextarea,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BAlert,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
    BFormCheckboxGroup,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      formState: {},
      filteredOpportunities: [],
      id: this.$route.params.id,
      isEdit: false,
      selectedStatus: null,
      showTable: false,
      changingOpportunity: null,
      showModal: false,
      currentTab: 'All',
      searchQuery: '',
      pageOptions: [3, 5, 10],
      perPage: 5, // Default items per page
      selectedColumns: ['name', 'leadClientName', 'salespersonId', 'status', 'stage', 'description', 'estimateValue', 'openDate', 'expectedCloseDate', 'closeDate', 'funnel', 'actions'], // Default selected columns
      columnOptions: [
        { value: 'leadClientName', text: 'Customer / Lead' },
        { value: 'salespersonId', text: 'Assigned To' },
        { value: 'stage', text: 'Stage' },
        { value: 'description', text: 'Description' },
        { value: 'estimateValue', text: 'Amount' },
        { value: 'openDate', text: 'Open Date' },
        { value: 'expectedCloseDate', text: 'Expected Close Date' },
        { value: 'closeDate', text: 'Close Date' },
        { value: 'funnel', text: 'Days In Funnel' },
      ],
      fields: [
        { key: "name", sortable: true },
        { key: "leadClientName", label: "Customer / Lead" },
        { key: "salespersonId", label: "Assigned To" },
        { key: "status" },
        { key: "stage", label: "Stage", sortable: true },
        { key: "description", label: "Description" },
        { key: "estimateValue", sortable: true, label: "Amount" },
        { key: "openDate", sortable: true, label: "Open Date" },
        { key: "expectedCloseDate", sortable: true, label: "Expected Close Date" },
        { key: "closeDate", sortable: true, label: "Close Date" },
        { key: "funnel", sortable: true, label: "Days In Funnel" },
        { key: "actions" },
      ],
      currentPage: 1,
      perPage: 5,
      form: {
        name: "",
        status: "",
        estimateValue: 0,
        expectedCloseDate: "",
        description: "",
        salespersonId: null,

      },
      editFormData: {
        name: "",
        leadClientId: this.id,
        status: "",
        estimateValue: 0,
        expectedCloseDate: "",
        description: "",
        salespersonId: null,
      },

      statusOptions: [
        { value: 'New', text: "New" },
        { value: 'InProgress', text: "In Progress" },
        { value: 'ClosedWon', text: "Closed Won" },
        { value: 'ClosedLost', text: "Closed Lost" },
      ],
      salesStageOptions: [
        "Qualification",
        "Proposal",
        "Negotiation",
        "Closing",
      ],
      sortBy: '',
      sortDesc: false,
      opplist: [],
      optionsCustomer: [],
      salesPersonOptions: [],
      submitting: false,
    };
  },

  computed: {
    ...mapGetters("salesPersonModule", {
      SalesPersonList: "salesperson",
      loading: "loading",
    }),
    ...mapGetters("leadModule", {
      leadList: "leads",
      //opportunity: "opportunity",
      loadingopp: "loading",
    }),

    ...mapGetters("customerModule", {
      CustomerList: "customers",
      loadingCustomer: "loading",
    }),

    ...mapGetters("opportunityModule", {
      opportunity: "opportunities",
      opportunityId: "opportunityId",
      loadingopp: "loading",
    }),

    rows() {
      return this.filteredOpportunities.length;
    },

    dynamicFields() {
      return this.fields.filter(field => this.selectedColumns.includes(field.key));
    },
    currentStatus() {
      const statusMapping = {
        0: 'All',
        1: 'New',
        2: 'InProgress',
        3: 'ClosedWon',
        4: 'ClosedLost'
      };
      return statusMapping[this.currentTab];
    },

    filteredOpportunitiesByTab() {
      if (this.currentStatus === 'All') {
        return this.filteredOpportunities;
      }
      return this.filteredOpportunities.filter(
        (opportunity) => {
          if(opportunity.status === this.currentStatus && this.searchQuery){
              return opportunity
            }else if(opportunity.status === this.currentStatus){
              return opportunity;
            }
        }
      );

    },

    isStatusChangeDisabled() {
      if (!this.changingOpportunity || !this.selectedStatus) return true;
      const currentStatus = this.changingOpportunity.status;
      const newStatus = this.selectedStatus;
      if (currentStatus === newStatus) return true;
      if (currentStatus === "New" && newStatus === "ClosedWon") return true;
      if (["ClosedLost", "ClosedWon"].includes(currentStatus)) return true;
      return false;
    },
  },
  methods: {
    ...mapActions("opportunityModule", ["getOpportunityListAction", "addOpportunitiesAction", "removeOpportunitiesAction", "updateOpportuntiesAction", "getOpportunityByIdAction", "updateOpportunityStatusAction"]),
    ...mapActions("leadModule", ["getLeadListAction", "getLeadOpportunityAction"]),
    ...mapActions("customerModule", ["getCustomersListAction"]),
    ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),
    formatDate(dateString) {
      if (!dateString) return ' - ';
      const date = new Date(dateString);
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return date.toLocaleDateString(undefined, options);
    },
    beautifyStatus(status) {
      return status
        .split(/(?=[A-Z])/)
        .join(' ')
        .trim();
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    formatAmount(value) {
      const nullAmount = 0;
      if (value == null) return nullAmount.toFixed(2);
      return value.toFixed(2);
    },

    resetForm() {
      this.form = {
        name: "",
        leadClientId: this.id,
        status: "",
        estimateValue: 0,
        expectedCloseDate: "",
        description: "",
      };
    },
    getSalePersonName(id) {
      const salesPerson = this.SalesPersonList.find((s) => s.id === id);
      return salesPerson ? salesPerson.firstName + " " + salesPerson.lastName : "";
    },

    getLeadName(id) {
      const lead = this.leadList.find(v => v.id === id);
      return lead ? lead.otherName : null;
    },

    getBadgeVariant(status) {
      const statusVariantMapping = {
        'New': 'info',
        'InProgress': 'secondary',
        'ClosedWon': 'success',
        'ClosedLost': 'danger'
      };
      return statusVariantMapping[status] || 'secondary'; // Fallback color
    },

    async prepareEditOpportunity(item) {
      //console.log("item", item);
      const ops = item;

   await this.getOpportunityByIdAction(ops.id);
    //console.log("opportunity", this.opportunityId);
   const salesPerson = this.SalesPersonList.find(s => s.id === this.opportunityId.salespersonId);
   //console.log("salesperson", salesPerson);

      this.editFormData = {
        id: item.id,
        name: item.name,
        leadClientId: item.leadClientID,
        status: item.status,
        estimateValue: item.estimateValue,
        expectedCloseDate: item.expectedCloseDate,
        description: item.description,
        salespersonId: salesPerson ? salesPerson.id : "",
      };

      // if(salesPerson != null || salesPerson != undefined || ){
      //   this.editFormData.salespersonId = salesPerson.id;
      // }

      console.log("editdataform", this.editFormData);

      this.$bvModal.show('edit-opportunity-modal');
    },

    viewOpportunity(id) {
      return "/opportunity/view/" + id;
    },
    promptChangeStatus(opportunity) {
      this.changingOpportunity = opportunity;
      this.selectedStatus = opportunity.status;
      this.$bvModal.show('change-Opportunity-status-modal');
    },

    async changeStatus() {
      if (!this.changingOpportunity || !this.selectedStatus) {
        this.error('Please select a status.');
        return;
      }

      const result = await this.$swal({
        title: 'Are you sure?',
        text: 'You are about to change the status of this opportunity.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, change it!',
        cancelButtonText: 'No, keep it',
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false
      });

      if (result.isConfirmed) {
        this.$swal({
          title: 'Updating Status...',
          text: 'Please wait while the status is being updated...',
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          }
        });

        try {
          const payload = {
            id: this.changingOpportunity.id,
            status: this.selectedStatus
          };

          await this.updateOpportunityStatusAction(payload);
             this.$swal.hideLoading();
           this.success('Status updated successfully!');
          
        } catch (error) {
          this.$swal.hideLoading();
          console.log(error, error.response.data)
          this.error(error.response.data.message ?? 'There was a problem updating the status. Please try again.');
        } finally {
          this.$bvModal.hide('change-Opportunity-status-modal');
          await this.getLeadOpportunityAction(this.id)
          .then((response) => {
        this.filteredOpportunities = [...this.opportunity];
      })
      .catch((response) => {
        console.log(response);
      });
        }
      }
    },
    isStatusChangeAllowed(currentStatus, newStatus) {
      const allowedTransitions = {
        New: ["In Progress", "Closed Lost"],
        "In Progress": ["New", "Closed Lost", "Closed Won"],
      };
      return allowedTransitions[currentStatus]?.includes(newStatus) ?? false;
    },

    async deleteOpportunity(opportunityId) {
      const result = await this.$swal({
        title: 'Are you sure?',
        text: 'You will not be able to recover this opportunity!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false
      });

      if (result.isConfirmed) {
        this.$swal({
          title: 'Deleting...',
          text: 'Please wait while the opportunity is being deleted...',
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          }
        });

        try {
          await this.removeOpportunitiesAction(opportunityId);
          this.$swal.hideLoading();
          this.success("Opportunity deleted successfully");
          await this.getLeadOpportunityAction(this.id)
          .then(() => {
            this.opplist = this.opportunity.filter((x) => x.leadClientID == this.id);
            this.totalRows = this.opplist.length;
          })
        } catch (error) {
          this.$swal.hideLoading();
          this.error("There was a problem deleting the opportunity. Please try again.");
        } finally {
          this.$swal.close();
        }
      }
    },

    // Helper methods
    success(message) {
      this.$swal({
        title: "Success!",
        text: message,
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    error(message) {
      this.$swal({
        title: 'Error!',
        text: message,
        icon: 'error',
        customClass: {
          confirmButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
    },

    /////Edit
    async updateOpportunity() {
    
      const isValid = await this.$refs.EditForm.validate();
      if (isValid) {
        this.submitting = true;
        try {
          const payloadEdit = {
            ...this.editFormData,
            leadClientId: this.id,
            estimateValue: parseFloat(this.editFormData.estimateValue),
            expectedCloseDate: this.editFormData.expectedCloseDate === "" ? null : this.editFormData.expectedCloseDate,
          };
          await this.updateOpportuntiesAction({ id: this.editFormData.id, payload: payloadEdit });
          this.success('Opportunity updated successfully!');
          await this.getOpportunityListAction()
      .then((response) => {
       // this.filteredOpportunities = [...this.opportunity];
         this.opplist = this.opportunity.filter((x) => x.leadClientID == this.id);
      // Update total rows and reset pagination if needed
      console.log("opportunitylist", this.opplist);
      this.totalRows = this.opplist.length;
      })
      .catch((response) => {
        console.log(response);
      });
        } catch (error) {
          console.error("Error updating opportunity:", error);
          this.error("There was an error updating the opportunity. Please try again.");
        } finally {
          this.submitting = false;
          this.$bvModal.hide('edit-opportunity-modal');
          await  this.getOpportunityListAction()
      .then((response) => {
       // this.filteredOpportunities = [...this.opportunity];
         this.opplist = this.opportunity.filter((x) => x.leadClientID == this.id);
      // Update total rows and reset pagination if needed
      console.log("opportunitylist", this.opplist);
      this.totalRows = this.opplist.length;
      })
      .catch((response) => {
        console.log(response);
        this.submitting = false;
      });
        }
      }
    },


    /////Add
    async onSubmit() {
      this.submitting = true;
      const isValid = await this.$refs.AddForm.validate();
      if (isValid) {
        try {
          const payload = {
            ...this.form,
            leadClientId: this.id,
            estimateValue: parseFloat(this.form.estimateValue),
            expectedCloseDate: this.form.expectedCloseDate === "" ? null : this.form.expectedCloseDate,
          };
          await this.addOpportunitiesAction(payload).then(() => {
            this.success('Opportunity added successfully!');
                     this.getOpportunityListAction()
      .then(() => {
       // this.filteredOpportunities = [...this.opportunity];
         this.opplist = this.opportunity.filter((x) => x.leadClientID == this.id);
      // Update total rows and reset pagination if needed
      console.log("opportunitylist", this.opplist);
      this.totalRows = this.opplist.length;
      });
          });
          
        } catch (error) {
          this.error("There was an error adding the opportunity, please try again later");
        } finally {
          this.submitting = false;
          this.$bvModal.hide("add-opportunity-modal");
      //     await this.getLeadOpportunityAction(this.id)
      //     .then((response) => {
      //   this.filteredOpportunities = [...this.opportunity];
      // })
      // .catch((response) => {
      //   console.log(response);
      // });
      this.getOpportunityListAction()
      .then(() => {
       // this.filteredOpportunities = [...this.opportunity];
         this.opplist = this.opportunity.filter((x) => x.leadClientID == this.id);
      // Update total rows and reset pagination if needed
      console.log("opportunitylist", this.opplist);
      this.totalRows = this.opplist.length;
      });
          this.resetForm();
        }
      } else {
        this.submitting = false;
      }
    },
    filterTable() {
      this.filteredOpportunities = this.opportunity.filter((item) => {
        const matchesName = this.filters.name
          ? item.name && item.name.toLowerCase().includes(this.filters.name.toLowerCase())
          : true;

        const matchesLeadClientName = this.filters.leadClientName
          ? item.leadClientName && item.leadClientName.toLowerCase().includes(this.filters.leadClientName.toLowerCase())
          : true;

        const matchesSalesperson = this.filters.salespersonId
          ? this.getSalePersonName(item.salespersonId).toLowerCase().includes(this.filters.salespersonId.toLowerCase())
          : true;

        const matchesDescription = this.filters.description
          ? item.description && item.description.toLowerCase().includes(this.filters.description.toLowerCase())
          : true;

        const matchesFunnel = this.filters.funnel
          ? item.funnel && String(item.funnel).toLowerCase().includes(this.filters.funnel.toLowerCase())
          : true;

        const matchesStatus = this.filters.status
          ? item.status === this.filters.status
          : true;

        const matchesStage = this.filters.stage
          ? item.stage && item.stage.toLowerCase().includes(this.filters.stage.toLowerCase())
          : true;

        const matchesCreatedOnRange = this.filters.createdOnRange && this.filters.createdOnRange.length === 2
          ? item.createdOn &&
          new Date(item.createdOn) >= new Date(this.filters.createdOnRange[0]) &&
          new Date(item.createdOn) <= new Date(this.filters.createdOnRange[1])
          : true;

        const matchesExpectedCloseDateRange = this.filters.expectedCloseDateRange && this.filters.expectedCloseDateRange.length === 2
          ? item.expectedCloseDate &&
          new Date(item.expectedCloseDate) >= new Date(this.filters.expectedCloseDateRange[0]) &&
          new Date(item.expectedCloseDate) <= new Date(this.filters.expectedCloseDateRange[1])
          : true;

        const matchesCloseDateRange = this.filters.closeDateRange && this.filters.closeDateRange.length === 2
          ? item.closeDate &&
          new Date(item.closeDate) >= new Date(this.filters.closeDateRange[0]) &&
          new Date(item.closeDate) <= new Date(this.filters.closeDateRange[1])
          : true;

        return (
          matchesName &&
          matchesLeadClientName &&
          matchesSalesperson &&
          matchesDescription &&
          matchesFunnel &&
          matchesStatus &&
          matchesStage &&
          matchesCreatedOnRange &&
          matchesExpectedCloseDateRange &&
          matchesCloseDateRange
        );
      });

      let opplist = this.filteredOpportunities.filter((x) => x.leadClientID == this.id);
      // Update total rows and reset pagination if needed
      console.log("opportunitylist", opplist);
      this.totalRows = opplist.length;
      this.currentPage = 1;
    },
    clearFilters() {
      // Reset text filters
      this.filters = {
        name: "",
        leadClientName: "",
        salespersonId: "",
        description: "",
        funnel: "",
        status: null,
        stage: "",
        createdOnRange: null,
        expectedCloseDateRange: null,
        closeDateRange: null,
      };
      // Reset filtered opportunities and pagination
      this.filteredOpportunities = [...this.opportunity];
      this.totalRows = this.filteredOpportunities.length;
      this.currentPage = 1; // Reset to the first page
    },
  },

  async mounted() {
    this.isEdit = HasPermission(PermissionList.Sales_Update);
    setTimeout(() => {
        this.showTable = true; // Step 2: Set to true after 3 seconds
    }, 5000);
    await this.getOpportunityListAction()
      .then((response) => {
       // this.filteredOpportunities = [...this.opportunity];
         this.opplist = this.opportunity.filter((x) => x.leadClientID == this.id);
      // Update total rows and reset pagination if needed
      console.log("opportunitylist", this.opplist);
      this.totalRows = this.opplist.length;
      })
      .catch((response) => {
        console.log(response);
      });
      await this.getSalesPersonListAction().then(() => {
        this.SalesPersonList.map((v, i) => 
        this.salesPersonOptions.push({
          value: v.id,
          text: `${v.firstName}` + " " + `${v.lastName}`,
          item: v,
        })
      );
    });
    await this.getCustomersListAction().then(() => {
      this.CustomerList.map((v, i) =>
        this.optionsCustomer.push({
          value: v.id,
          text: `${v.otherName} ${v.surname ?? ''}`,
          item: v,
        })
      );
    });
    await this.getLeadListAction().then(() => {
      this.leadList.map((v, i) => {
        this.optionsCustomer.push({
          value: v.id,
          text: `${v.otherName} ${v.surname ?? ''}`,
          item: v,
        });
      });
    });
    this.salesPersonOptions = fnSortingDropdown(this.salesPersonOptions);
  },
  setup(props){
    return{
      PermissionList,
      HasPermission
    }
  }
};
</script>